import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { Menu } from 'antd'

import { showAppModal } from '~/redux/actions/app'

const mapStateToProps = (state) => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  showAppModal
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(props => {
  const handleClick = event => {
    if (props.selected !== event.key) {
      if (event.key === 'phone') {
        props.showAppModal('PhoneSigninModal')
      } else if (event.key === 'wechat') {
        props.showAppModal('WechatSigninModal')
      }
    }
  }

  const items = [
    {
      label: "密码登录",
      key: "phone"
    },
    {
      label: "微信登录",
      key: "wechat"
    }
  ]

  return (
    <Menu
      mode='horizontal'
      selectedKeys={[props.selected]}
      onClick={handleClick}
      items={items}
    />
  )
})
